<template>
  <div v-if="!delback" class="global-searchqx fl">
    <!-- <Icon type="md-arrow-back" /> -->

    <div
      v-if="isback"
      @click="routerback"
      class="u-flex pot"
      style="width: 24px; height: 20px; margin-right: 16px"
    >
      <img :src="arrowleft" width="24px" height="20px" />
    </div>
    <div class="global-search" :class="{ 'bullen-serch': delback || allback }">
      <div class="u-flex" style="height: 100%; padding-left: 24px">
        <div class="input">
          <input
            @focus="inputFocus"
            v-model="text"
            @input="serText"
            @blur="inputBlue"
            @keyup.enter="serhsertimr"
            placeholder="搜索"
          />
          <img
            src="@/assets/images/serch.png"
            class="pot"
            style="width: 28px; position: relative; left: 18px"
            @click="serhsertimr"
          />
        </div>
      </div>
      <!--  v-if="totlBo" -->
      <div @mouseover="totbometh" class="tootil" v-if="totlBo">
        <template v-if="isSerch">
          <template>
            <div class="" style="margin-bottom: 28px">
              <div class="c-title">
                <div>最近搜索</div>
                <div class="img pot" v-if="recommends && recommends.length > 0">
                  <Tooltip theme="light" content="删除">
                    <img
                      @click="clearSerList"
                      style="width: 100%; height: 100%"
                      :src="remove"
                    />
                  </Tooltip>
                </div>
              </div>
              <div
                class="index-ser-items"
                v-if="recommends && recommends.length > 0"
              >
                <div
                  class="i-sitem pot"
                  v-for="(index1, key) in recommends"
                  @click="sertimr(index1, 0)"
                  :key="key"
                >
                  {{ index1 }}
                </div>
              </div>
              <template v-else>
                <div
                  class="mw mh u-flex u-row-center"
                  style="
                    font-size: 14px;
                    color: rgba(0, 0, 0, 0.851);
                    position: relative;
                    top: 10px;
                  "
                >
                  暂无最近搜索
                </div>
              </template>
            </div>
          </template>
          <!-- <template>
          <div  v-if="list.length>0">
            <div class="c-title">
              <div>推荐搜索</div>
            </div>
            <div class="index-ser-items">
              <div @click="sertimr(index,1)"
               class="i-sitem pot " v-for="(index,key) in list" :key="key">{{index}}</div>
            </div>
          </div>
        </template> -->
        </template>
        <template v-else>
          <div
            class="sertjitem"
            @click="sertimr(item, 0)"
            v-for="(item, key) in accoption"
            :key="key"
          >
            {{ item }}
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import serch from "@/assets/images/serch.png";
import remove from "@/assets/images/remove.png";
import debounce from "@/util/debounce";
import { mapState } from "vuex";
import { getAssociate, getSearchHistory, hisleClear } from "@/api/pubrequst";
import ls from "store2";
import arrowleft from "@/assets/images/icon-arrow-left.png";
export default {
  name: "Serch",
  props: {
    delback: {},
    allback: {},
  },
  watch: {
    url: {
      immediate: true,
      handler: function (data) {
        const { form, to } = data;
        if (form == "search" && to != "search") {
          this.text = "";
        }
        if (to == "search") {
          this.isback = true;
       
        } else {
          this.isback = false;
        }
      },
    },
    // url(data) {

    // },
    delback: {
      deep: true,
      immediate: true,
      handler: function (value) {},
    },
  },
  data() {
    return {
      arrowleft,
      isback: true,
      timer: null,
      serch,
      remove,
      totlBo: false,
      inhider: false, //清除的判断
      list: [],
      recommends: null,
      text: "",
      accoption: [],
      isserLoaing: false,
    };
  },
  computed: {
    ...mapState({
      url: (state) => state.pub.url,
    }),
    isSerch() {
      if (!this.text) {
        this.text = "";
      }
      return this.text == "" ? true : false;
    },
  },
  methods: {
    routerback() {
      this.$router.go(-1);
    },
    serText(e) {
      debounce(
        async () => {
          if (this.isserLoaing) {
            //如果搜索结束 则推荐词不在搜索
            this.isserLoaing = false;
            return;
          }
          let keyword = e.target.value;
          let { data } = await getAssociate({
            keyword,
          });
          this.accoption = data;
          if (!this.totlBo) {
            if (!this.timer) {
              this.totlBo = true;
            }
          }
        },
        500,
        false
      );
    },
    clearSerList() {
      this.inhider = true;
      hisleClear().then((e) => {
        this.recommends = [];
      });
    },
    serhsertimr(e) {

      let text = this.text;
      this.isserLoaing = true;
      this.sertimr(text, 1);
    },
    sertimr(row, index) {
      this.text = row;
      this.inhider = false;
      this.totlBo = false;

      this.$store.commit("serach/setkeword", row);
      const currentRouteName = this.$route.name;

      if (!(currentRouteName == "sarch")) {
        this.$router.push("/search");
      }
      let t = setTimeout(() => {
        this.gethistlist();
        clearTimeout(t);
      }, 200);
    },
    totbometh() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    },
    setrecoder() {
      return ls.get("recommends");
    },
    async gethistlist() {
      let { data } = await getSearchHistory();
      this.recommends = data.history;
      this.list = data.common;
    },
    async inputFocus() {
      if (this.text == "") {
        this.gethistlist();
      } else {
        let obj = {
          target: {
            value: this.text,
          },
        };
        this.serText(obj);
      }
      this.inhider = false;
      // if (!this.recommends) {
      //   this.recommends = this.setrecoder()
      // }
      this.$nextTick(() => {
        if (!this.totlBo) {
          this.totlBo = true;
        }
      });
    },
    inputBlue() {
      if (this.totlBo) {
        this.timer = setTimeout(() => {
          if (!this.inhider) {
            this.totlBo = false;
          }
        }, 150);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.global-searchqx {
  position: relative;
  margin-right: 25px;
  display: flex;
  align-items: center;
}
.bullen-serch {
  border: 1px solid rgba(201, 201, 201, 0.5);
  background: none !important;

  input {
    background: none !important;
    color: #fff;
  }

  .tootil {
    background: #172649 !important;
    box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.1608) !important;
  }

  .c-title {
    color: rgba(255, 255, 255, 0.851) !important;
  }

  .i-sitem {
    border: 1px solid #323f5c !important;
    color: #dcdee4 !important;
  }
  .sertjitem {
    color: #dcdee4 !important;
  }
}

.global-search {
  width: 642px;
  height: 40px;

  background: #f7f8fc;
  border-radius: 20px;

  .input {
    flex: 1;
    height: 100%;
    display: flex;
    align-items: center;
    margin-left: 8px;

    input {
      border: none;
      height: 90%;
      width: 90%;
      background: #f7f8fc;
      font-size: 14px;

      &::placeholder {
        font-size: 14px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #cccdd1;
      }
    }
  }

  .tootil {
    width: 100%;
    background: #ffffff;
    position: relative;
    left: 0;
    min-height: 116px;
    padding: 15px 20px;
    box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.1608);
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
  }

  .c-title {
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.851);
    line-height: 1;
    display: flex;
    align-items: center;

    .img {
      width: 18px;
      height: 18px;
      position: relative;
      top: -1px;
      left: 6px;
    }
  }

  .index-ser-items {
    margin-top: 12px;
    display: flex;
    flex-wrap: wrap;

    .i-sitem {
      padding: 4px 11px;
      font-size: 14px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #878787;
      margin-right: 16px;
      margin-bottom: 12px;
      border: 1px solid #dddddd;
      border-radius: 2px;
      line-height: 1;
    }
  }
}

.sertjitem {
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.851);
  line-height: 1;
  margin-bottom: 17px;
  cursor: pointer;
}
</style>